module.exports = __webpack_public_path__ + "static/media/template2.35781737.png";